import { Link } from "react-router-dom";

const StarterOptionLink = (props: {
  title: string;
  subtitle: string;
  to: string;
  isYellow?: boolean;
}) => {
  return (
    <Link
      to={props.to}
      className={`w-[528px] h-[74px] pl-12 rounded-lg border items-center gap-[11px] inline-flex ${
        props.isYellow
          ? "border-[#f6d346] border-2"
          : "border-zinc-200 hover:border-zinc-600"
      }  hover:bg-zinc-100 focus:border-zinc-600 focus:bg-zinc-100`}
    >
      <div className="flex-col justify-start items-start gap-0.5 inline-flex">
        <div className="justify-center items-center gap-2.5 inline-flex">
          <div className="text-zinc-900 text-xl font-semibold font-['Inter']">
            {props.title}
          </div>
        </div>
        <div className="justify-center items-center gap-2.5 inline-flex">
          <div className="text-[#475467] text-xs font-medium font-['Inter']">
            {props.subtitle}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default StarterOptionLink;
